export const ADD_TAX_SUCCESS = 'ADD_TAX_SUCCESS';

export const createFinalizeAddTax = tax => ({
  type: ADD_TAX_SUCCESS,
  payload: {
    tax
  }
});
